
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  troughListItemWidth: {
    id: "TroughListItemWidth.width",
    defaultMessage: "Width",
  }, 
  troughListItemMinWidth: {
    id: "TroughListItemWidth.minWidth",
    defaultMessage: "Min Width",
  }, 
  troughListItemDepth: {
    id: "TroughListItemDepth.depth",
    defaultMessage: "Depth",
  },
  troughListItemMinDepth: {
    id: "TroughListItemDepth.minDepth",
    defaultMessage: "Min Depth",
  },
  troughListItemMinDimensions: {
    id: "TroughListItemDepth.minDimensions",
    defaultMessage: "min. washbasin width x depth",
  },
  troughListItemHeight: {
    id: "TroughListItemHeight.height",
    defaultMessage: "Height",
  }, 
  troughListItemUnavailable: {
    id: "TroughListItemHeight.unavailable",
    defaultMessage: "available from August 2023",
  },
});

export default MESSAGES;